var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.669,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6681 20C16.1911 20 20.6681 15.523 20.6681 10C20.6681 4.477 16.1911 0 10.6681 0C5.14513 0 0.668152 4.477 0.668152 10C0.668152 15.523 5.14513 20 10.6681 20ZM14.7341 5.934C14.8745 6.07463 14.9534 6.26525 14.9534 6.464C14.9534 6.66275 14.8745 6.85337 14.7341 6.994L11.7281 10L14.7331 13.005C14.8656 13.1472 14.9377 13.3352 14.9343 13.5295C14.9308 13.7238 14.8521 13.9092 14.7147 14.0466C14.5773 14.184 14.3919 14.2627 14.1976 14.2662C14.0033 14.2696 13.8153 14.1975 13.6731 14.065L10.6681 11.062L7.66312 14.067C7.59446 14.1407 7.51166 14.1998 7.41966 14.2408C7.32766 14.2818 7.22834 14.3038 7.12764 14.3056C7.02694 14.3074 6.92691 14.2888 6.83352 14.2511C6.74014 14.2134 6.6553 14.1573 6.58408 14.086C6.51287 14.0148 6.45672 13.93 6.419 13.8366C6.38128 13.7432 6.36276 13.6432 6.36453 13.5425C6.36631 13.4418 6.38835 13.3425 6.42934 13.2505C6.47033 13.1585 6.52944 13.0757 6.60312 13.007L9.60611 10L6.60212 6.995C6.52844 6.92634 6.46933 6.84354 6.42834 6.75154C6.38735 6.65954 6.36531 6.56023 6.36353 6.45952C6.36176 6.35882 6.38028 6.25879 6.418 6.1654C6.45572 6.07201 6.51187 5.98718 6.58308 5.91596C6.6543 5.84474 6.73914 5.7886 6.83252 5.75088C6.92591 5.71316 7.02594 5.69463 7.12664 5.69641C7.22735 5.69818 7.32666 5.72023 7.41866 5.76122C7.51066 5.80221 7.59346 5.86131 7.66212 5.935L10.6681 8.938L13.6731 5.933C13.8137 5.79255 14.0043 5.71366 14.2031 5.71366C14.4018 5.71366 14.5925 5.79255 14.7331 5.933",
    fill: "#E83323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.92749d23cfd25ebba8988c4f84c268a8.svg";
export { ForwardRef as ReactComponent };